import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=ec4f723a&scoped=true"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=ec4f723a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4f723a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec4f723a')) {
      api.createRecord('ec4f723a', component.options)
    } else {
      api.reload('ec4f723a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=ec4f723a&scoped=true", function () {
      api.rerender('ec4f723a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/lib/Accordion.vue"
export default component.exports